/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Quartier (zone IRIS) d\'une commune, issu de la table `localite` du datalake.
 */
export const quartierSchema = z.object({
      "oid": z.string().describe("Identifiant stable du quartier dans le datalake, persisté dans `Address.quartierOid`."),
  "nom": z.string()
      }).describe("Quartier (zone IRIS) d'une commune, issu de la table `localite` du datalake.")